import React from "react";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";

/**
 * A generic component to render other input-related components styled to Material-UI.
 */
function GenericField({
  className,
  disabled,
  error,
  fullWidth,
  inputComponent,
  inputProps,
  label,
  margin,
  onChange,
  required,
  ...props
}) {
  return (
    <FormControl
      className={className}
      error={error}
      disabled={disabled}
      fullWidth={fullWidth}
      margin={margin}
    >
      {label && (
        <InputLabel
          error={error}
          disabled={disabled}
          required={required}
          shrink
        >
          {label}
        </InputLabel>
      )}
      <Input
        error={error}
        disabled={disabled}
        fullWidth={fullWidth}
        required={required}
        onChange={onChange}
        // Important: Use `inputComponent` to render any kind of component you want with Material-UI
        // styling
        inputComponent={inputComponent}
        // Use `inputProps` to pass props to the `inputComponent` provided
        inputProps={inputProps}
        // The rest of the top-level props are passed to this component (Material-UI's `Input`)
        {...props}
      />
    </FormControl>
  );
}

export default GenericField;



// WEBPACK FOOTER //
// ./src/components/Forms/GenericField.jsx